import { CircleExperts } from "../circles/CircleExperts";
import { Currencies } from "../Currencies";
import { EventEntryFee, EventPaymentType } from "./AnyoEvents";

export interface AnyoForum  {
    name: string;
    description: string;
    categoryId: string;
    categoryName: string;
    active: boolean;
    visibleFrom: Date;
    entryFee: EventEntryFee[];
    forumStartDate: Date;
    forumEndDate: Date | null;
    presenterDetailIds: string[];
    paymentType: EventPaymentType;
    bannerImages: string[];
    squareImage: string;
    presenterDetails?: CircleExperts[];
    registrationCutOffDate: Date | null;
    maxRegistrations?: number;
    language?: string;
    tags?: ForumTags[];
    payoutDetails?: {
      presenterId: string;
      payout: PresenterPayoutDetail;
    }[];
    shareMessage?: string;
    shareImage?: string;
    partners?:  {
        id: string;
        name: string;
        partnerId: string;
      }[];
    applicableClubPasses?: {
        passId: string;
        passName: string;
      }[];
    entryFeeHistory?: EventEntryFee[];
    confirmedRegistrations?: number;
  }
  
  export interface PresenterPayoutDetail {
    currency: Currencies;
    currencySymbol: string;
    amount: number;
  }
  
  export enum ForumTags {
    TEST_FORUM = "TEST_FORUM",
    TEST_REAL_PAYMENT = "TEST_REAL_PAYMENT",
    FOREVER_FORUM = "FOREVER_FORUM",
    CORPORATE_ONLY = "CORPORATE_ONLY",
    AUTO_PAYMENT = "AUTO_PAYMENT",
    MANUAL_PAYMENT = "MANUAL_PAYMENT",
    IS_DISCUSSION_AVAILABLE = "IS_DISCUSSION_AVAILABLE",
    CAN_USER_POST = "CAN_USER_POST",
    CAN_EXPERT_POST = "CAN_EXPERT_POST",
  }
  